import * as React from 'react';
import { Dispatch } from 'redux';
import { LoginRequest as ILoginRequest, SessionViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as SessionNormalizers from '../normalizers/sessionNormalizers';

export class LoginRequest extends BaseApiPostRequest<
  SessionViewModel,
  EntityNormalizers.NormalizedEntityArray<SessionNormalizers.NormalizesSessions>
> {
  constructor(loginFormData: ILoginRequest, component: React.Component, dispatch: Dispatch) {
    super(loginFormData, component, dispatch);
    this.path = `/sessions`;
    this.normalizeMethod = SessionNormalizers.normalizeSession;
  }

  protected addAuthentication() {
    // Do nothing - unauthenticated request
  }
}
